import type { ScheduleAddress } from '@shared/types/schedules';

export const addressToString = (address: ScheduleAddress) => {
	const params = ['city', 'street', 'house', 'apartment'];
	const addressArr = [];
	for (const param of params) {
		if (address && address[param] !== null) {
			switch (param) {
				case 'city':
					addressArr.push(`г. ${address[param]}`);
					break;
				case 'street':
					addressArr.push(`ул. ${address[param]}`);
					break;
				case 'house':
					addressArr.push(`д. ${address[param]}`);
					break;
				case 'apartment':
					addressArr.push(`кв. ${address[param]}`);
					break;
				default:
					break;
			}
		}
	}
	return addressArr.join(', ');
};
